export { default as en } from "./en.lang";

import vuetifyAr from "vuetify/es5/locale/ar";
import localAr from "./ar.lang";

export const ar = {
  ...vuetifyAr,
  ...localAr,
};
